import * as types from 'store/questionTypes/questionTypesTypes'

const initialState = []

const questionTypesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_QUESTION_TYPES_SUCCEEDED: {
      return action.payload.json.questionTypes
    }
    default: return state
  }
}

export default questionTypesReducer
